
import { Event } from '@process-advisor/process-miner/api/events';
import { getEventEmitter } from '@process-advisor/process-miner/processMiner/processMiner';

export type Props = {
    data: {
        source: string,
        title: string,
    }
}

export const openWorkflowModal = ({ data }:  Props) => {
    let eventEmitter = getEventEmitter()
    eventEmitter.emit(Event.openWorkflowModal, { data });
};

